<!-- Slideout setting section -->
<cv-module-custom-setting-section *ngIf="moduleManager.settingsView == 'slideout'" [moduleManager]="moduleManager">
    <div class="custom-setting-section-title">
        <!-- The header of this section -->
        ETS {{ getLocalizationString("Settings", "Settings") }}
    </div>
    <div class="custom-setting-section-context">
        <!-- Context beneath the header -->
        {{ getLocalizationString("Group_By", "Group By") }} | {{ getLocalizationString("Columns", "Columns")}} | {{ getLocalizationString("Data", "Data") }}
    </div>
    <div class="custom-setting-section-body">
        <div class ="container" *ngIf="initialized && !dataLoading">
            <div class="row mb-2 " style="max-width: 280px;">
                <mat-label for="groupBySetting" class=" mb-1 body-2 color-whaleTail">{{ getLocalizationString("Group_By", "Group By") }}</mat-label>
                <mat-select id="groupBySetting" class="form-control" [(ngModel)]="groupBySelected" multiple 
                    [placeholder]="getLocalizationString('None', 'None')" 
                    [compareWith]="compareWith"
                >
                    <mat-option *ngFor="let option of groupByOptions" [value]="option">{{option}}</mat-option>
                </mat-select>
            </div>
            <div class="row mb-2" style="max-width: 280px;">
                <mat-label for="columnSetting" class=" mb-1 body-2 color-whaleTail">{{ getLocalizationString("Columns", "Columns")}}</mat-label>
                <mat-select id="columnSetting" class="form-control" [(ngModel)]="columnsSelected" multiple
                            [placeholder]="getLocalizationString('None', 'None')"
                            [compareWith]="compareWith">
                    <mat-checkbox class="ml-3 mt-2" (change)="toggleSelectAll()" [checked]="isAllSelected()"><span langSection="Common" langKey="All">All</span></mat-checkbox>
                    <mat-option *ngFor="let option of columnsOptions" [value]="option">{{option}}</mat-option>
                </mat-select>
            </div>
            <div class="row mb-2" style="max-width: 280px;">
                <mat-label for="dataSetting" class=" mb-1 body-2 color-whaleTail">{{ getLocalizationString("Data", "Data") }}</mat-label>
                <mat-select id="dataSetting" class="form-control" [(ngModel)]="dataSelected" multiple
                    [placeholder]="getLocalizationString('None', 'None')" 
                    [compareWith]="compareWith"
                >
                    <mat-option *ngFor="let option of dataOptions" [value]="option">{{option}}</mat-option>
                </mat-select>
            </div>
        </div>

        <div class="row" *ngIf="dataLoading">
            <div class="col position-relative" style="height: 200px; width: 200px;" >
                <cv-loader size="large" overay="false" class="d-block"></cv-loader>
            </div>
        </div>
    </div>
</cv-module-custom-setting-section>

<ng-container *ngIf="moduleManager.settingsView == 'modal'">
    <div cvModuleLegacyCustomSettingSection position="bottom" [moduleManager]="moduleManager">
        <div class="d-flex" *ngIf="this.initialized && !dataLoading">
            <div class="flex-fill d-flex flex-column mx-1">
                <div class="flex-fill d-flex flex-column mt-2 settingsSectionTitle">{{ getLocalizationString("Group_By", "Group By") }}</div>
                <mat-select [(ngModel)]="groupBySelected" multiple class="form-control"
                    [placeholder]="getLocalizationString('None', 'None')"  
                    [compareWith]="compareWith" 
                >
                    <mat-option *ngFor="let option of groupByOptions" [value]="option">{{option}}</mat-option>
                </mat-select>
            </div>

            <div class="flex-fill d-flex flex-column mx-1">
                <div class="flex-fill d-flex flex-column mt-2 settingsSectionTitle">{{ getLocalizationString("Columns", "Columns")}}</div>
                <mat-select [(ngModel)]="columnsSelected" multiple class="form-control"
                    [placeholder]="getLocalizationString('None', 'None')"  
                    [compareWith]="compareWith" 
                >
                    <mat-option *ngFor="let option of columnsOptions" [value]="option">{{option}}</mat-option>
                </mat-select>
            </div>

            <div class="flex-fill d-flex flex-column mx-1">
                <div class="flex-fill d-flex flex-column mt-2 settingsSectionTitle">{{ getLocalizationString("Data", "Data") }}</div>
                <mat-select [(ngModel)]="dataSelected" multiple class="form-control"
                    [placeholder]="getLocalizationString('None', 'None')"  
                    [compareWith]="compareWith" 
                >
                    <mat-option *ngFor="let option of dataOptions" [value]="option">{{option}}</mat-option>
                </mat-select>
            </div>
        </div>

        <div class="row" *ngIf="dataLoading">
            <div class="col position-relative" style="height: 200px; width: 200px;" >
                <cv-loader size="large" overay="false" class="d-block"></cv-loader>
            </div>
        </div>
    </div>
</ng-container>
